module.exports = __webpack_public_path__ + "static/media/Podcast_Ep_Besoain.4ace4fd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/podcast/Podcast_Ep_Besoain.mp3
// module id = qpTg
// module chunks = 0